var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("bottom-toolbar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _c("div", { staticClass: "layoutTop" }),
          _vm._v(" "),
          _c("f7-list", { attrs: { form: "" } }, [
            _c("li", [
              _c("a", { staticClass: "item-content", attrs: { href: "#" } }, [
                _c("div", { staticClass: "item-inner" }, [
                  _c("div", { staticClass: "item-title-row" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v("Group name"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-after" }, [
                    _vm._v(_vm._s(_vm.memberGroupLabel)),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("a", { staticClass: "item-content", attrs: { href: "#" } }, [
                _c("div", { staticClass: "item-inner" }, [
                  _c("div", { staticClass: "item-title-row" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v("Service " + _vm._s(_vm.service)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-after" }, [
                    _vm._v(_vm._s(_vm.actif)),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          1
            ? _c("div", { staticClass: "contactGroupTitle" }, [
                _vm._v("Members in this group"),
              ])
            : _vm._e(),
          _vm._v(" "),
          1
            ? _c(
                "f7-list",
                _vm._l(this.membersArray, function (value) {
                  return _c("f7-list-item", {
                    key: value.id,
                    attrs: { title: value.login },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "f7-button",
            {
              staticClass: "orangeConfirmationButton firstButtonMarginTop",
              attrs: { round: "", href: "/accountMembers/editMemberGroup/" },
            },
            [_vm._v("\n        Edit member group\n      ")]
          ),
          _vm._v(" "),
          _c(
            "f7-button",
            {
              staticClass: "orangeConfirmationButton",
              attrs: { round: "" },
              on: { click: _vm.removeMemberGroup },
            },
            [_vm._v("\n        Delete\n      ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "toolbarPageBottomBlank" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }